import React from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Useletter from '../Useletter';
import Foter from '../Foter';
function Sevpic() {
  return (
    <div>
     
<Container>

        
<Row>
  <Col><div className="para">
  <div className="item">   
<div id="shop"><b>Shopping Now</b></div>

  <div id="line"></div>
  <div id="cate">CATEGORY</div>
  <div id="line"></div>
  <div id="cate">FRAGRANCE CATEGORY</div>
  <div id="line"></div>
  <div id="cate">SIZE</div>
</div></div>
 </Col>
    <Col> <div className="box-content">
    <div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/j/j/jjsw-587_1_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=755&width=589&canvas=589:755&dpr=2"
   alt=''style={{height:'250px', width:'100%',
   
   }} /></div>
    <br /><br />
   <div className="hiding"><p>Black Cambric Printed Unstitched 3PC|-25<br />3223<br/>
   <b>PKR 2,590.00</b>
   </p>
   </div>
   <button className='bt'> ADD TO BAG</button>
</div></Col>
        <Col> <div className="box-content">
    <div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/j/j/jjsw-585_1_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=755&width=589&canvas=589:755&dpr=2"
   alt=''style={{height:'250px', width:'100%',
   
   }} /></div>
    <br /><br />
   <div className="hiding"><p>Black Cambric Printed Unstitched 3PC|-25<br />3223

 <br />
   <b>PKR 2,590.00</b>
   </p>
   </div>
  
   <button className='bt'> ADD TO BAG</button>
</div></Col>
<Col>
        <div className="box-content">
        <div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/j/j/jjsw-586_1_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=755&width=589&canvas=589:755&dpr=2"
           alt=''style={{height:'250px', width:'100%' }} /> </div>
   <br /><br />
   <div className="hiding"><p>Black Cambric Printed Unstitched 3PC|-25<br />3223<br/>
   <b>PKR 2,590.00</b>
   </p>
   </div>
   
   <button className='bt'> ADD TO BAG</button>
   </div>
   
        </Col>

      </Row>
    </Container>

    <Container>

        
<Row>
  <Col>
 </Col>
    <Col> <div className="box-content">
    <div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/j/j/jjsw-584_1_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=755&width=589&canvas=589:755&dpr=2"
   alt=''style={{height:'250px', width:'100%',
   
   }} /></div>
    <br /><br />
   <div className="hiding"><p>Black Cambric Printed Unstitched 3PC|-25<br />3223<br/>
   <b>PKR 2,590.00</b>
   </p>
   </div>
   <button className='bt'> ADD TO BAG</button>
</div></Col>
        <Col> <div className="box-content">
    <div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/j/j/jjsw-581_1_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=755&width=589&canvas=589:755&dpr=2"
   alt=''style={{height:'250px', width:'100%',
   
   }} /></div>
    <br /><br />
   <div className="hiding"><p>Black Cambric Printed Unstitched 3PC|-25<br />3223

 <br />
   <b>PKR 2,590.00</b>
   </p>
   </div>
  
   <button className='bt'> ADD TO BAG</button>
</div></Col>
<Col>
        <div className="box-content">
        <div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/j/j/jjsw-582_1_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=755&width=589&canvas=589:755&dpr=2"
           alt=''style={{height:'250px', width:'100%' }} /> </div>
   <br /><br />
   <div className="hiding"><p>Black Cambric Printed Unstitched 3PC|-25<br />3223<br/>
   <b>PKR 2,590.00</b>
   </p>
   </div>
   
   <button className='bt'> ADD TO BAG</button>
   </div>
   
        </Col>

      </Row>
    </Container>

    <Container>

        
<Row>
  <Col>
 </Col>
    <Col> <div className="box-content">
    <div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/j/j/jjsw-587_1_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=755&width=589&canvas=589:755&dpr=2"
   alt=''style={{height:'250px', width:'100%',
   
   }} /></div>
    <br /><br />
   <div className="hiding"><p>Black Cambric Printed Unstitched 3PC|-25<br />3223<br/>
   <b>PKR 2,590.00</b>
   </p>
   </div>
   <button className='bt'> ADD TO BAG</button>
</div></Col>
        <Col> <div className="box-content">
    <div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/j/j/jjsw-585_1_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=755&width=589&canvas=589:755&dpr=2"
   alt=''style={{height:'250px', width:'100%',
   
   }} /></div>
    <br /><br />
   <div className="hiding"><p>Black Cambric Printed Unstitched 3PC|-25<br />3223

 <br />
   <b>PKR 2,590.00</b>
   </p>
   </div>
  
   <button className='bt'> ADD TO BAG</button>
</div></Col>
<Col>
        <div className="box-content">
        <div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/j/j/jjsw-586_1_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=755&width=589&canvas=589:755&dpr=2"
           alt=''style={{height:'250px', width:'100%' }} /> </div>
   <br /><br />
   <div className="hiding"><p>Black Cambric Printed Unstitched 3PC|-25<br />3223<br/>
   <b>PKR 2,590.00</b>
   </p>
   </div>
   
   <button className='bt'> ADD TO BAG</button>
   </div>
   
        </Col>

      </Row>
    </Container>
    <Container>

        
<Row>
  <Col>
 </Col>
    <Col> <div className="box-content">
    <div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/j/j/jjsw-584_1_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=755&width=589&canvas=589:755&dpr=2"
   alt=''style={{height:'250px', width:'100%',
   
   }} /></div>
    <br /><br />
   <div className="hiding"><p>Black Cambric Printed Unstitched 3PC|-25<br />3223<br/>
   <b>PKR 2,590.00</b>
   </p>
   </div>
   <button className='bt'> ADD TO BAG</button>
</div></Col>
        <Col> <div className="box-content">
    <div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/j/j/jjsw-581_1_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=755&width=589&canvas=589:755&dpr=2"
   alt=''style={{height:'250px', width:'100%',
   
   }} /></div>
    <br /><br />
   <div className="hiding"><p>Black Cambric Printed Unstitched 3PC|-25<br />3223

 <br />
   <b>PKR 2,590.00</b>
   </p>
   </div>
  
   <button className='bt'> ADD TO BAG</button>
</div></Col>
<Col>
        <div className="box-content">
        <div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/j/j/jjsw-582_1_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=755&width=589&canvas=589:755&dpr=2"
           alt=''style={{height:'250px', width:'100%' }} /> </div>
   <br /><br />
   <div className="hiding"><p>Black Cambric Printed Unstitched 3PC|-25<br />3223<br/>
   <b>PKR 2,590.00</b>
   </p>
   </div>
   
   <button className='bt'> ADD TO BAG</button>
   </div>
   
        </Col>

      </Row>
    </Container>

<Useletter/>
<Foter/>
    </div>
  )
}

export default Sevpic
